import MuiButton from "@mui/material/Button";
import { withStyles } from "@mui/styles";

const Button = withStyles(MUITheme => ({
  root: props => {
    const rootStyles = {
      boxShadow: 'none',
      fontFamily: MUITheme.typography.fontFamily.primary,
      fontWeight: 'bold',
      fontSize: 18,
      padding: "7px 38px",
      lineHeight: "24px",
      type : 'button',
      variant : 'text',
    };
    if(props.color === "primary_new") {
      rootStyles.padding = "8px"
      rootStyles.lineHeight = "32px"
      rootStyles.color = MUITheme.palette.text.white.primary;
      rootStyles.backgroundColor = MUITheme.palette.new.background.primary;
      rootStyles.background = MUITheme.palette.new.background.btn;
      rootStyles.border = `1px solid ${MUITheme.palette.new.border.onPrimary}`;
      rootStyles.borderRadius = '4px';
      rootStyles["&:hover"] = {
        //backgroundColor: '#fff',
        background:'#fff',
        color: MUITheme.palette.new.text.primaryHover,
        boxShadow: 'none'
      };
      if (props.size === "small") {
        rootStyles.padding = "3px 8px"
        rootStyles.lineHeight = "24px"
        rootStyles.fontSize = 14
      }
    }
    if(props.color === "primary") {
      rootStyles.color = MUITheme.palette.text.white.primary;
      rootStyles.backgroundColor = '#259BEB';
      rootStyles.border = "1px solid #136BD6";
      rootStyles.borderRadius = '4px';
      rootStyles["&:hover"] = {
        backgroundColor: '#fff',
        color: '#259BEB',
        boxShadow: 'none'
      };
    }
    if(props.color === "secondary") {
      rootStyles.color = MUITheme.palette.text.white.primary;
      rootStyles.backgroundColor = '#ED1C24';
      rootStyles.border = "1px solid rgb(173 31 36)";
      rootStyles.borderRadius = '4px';
      rootStyles["&:hover"] = {
        backgroundColor: '#fff',
        color: '#ED1C24',
        boxShadow: 'none'
      };
    }
    if (props.color === "primary" && props.variant === "outlined") {
      rootStyles.color = MUITheme.palette.text.blue.primary;
      rootStyles.backgroundColor = '#E2F3FA';
      rootStyles.border = "1px solid #144DB0";
    }
    if (props.color === "primary" && props.variant === "outlined-transparent") {
      rootStyles.color = MUITheme.palette.text.blue.primary;
      rootStyles.backgroundColor = 'transparent';
      rootStyles.border = "1px solid rgb(37, 155, 235)";
      rootStyles["&:hover"] = {
        backgroundColor: '#259BEB',
        color: MUITheme.palette.text.white.primary,
        border: `1px solid #136BD6`
      };
    }
     if (props.color === "primary" && props.variant === "text") {
      rootStyles.color = '#259BEB';
      rootStyles.backgroundColor = 'transparent';
      rootStyles.border = "1px solid transparent";
      rootStyles["&:hover"] = {
        border: "1px solid #259BEB"
      };
    }
    if (props.variant === "outlined" && props.size==="small") {
      rootStyles.color = '#259BEB';
      rootStyles.backgroundColor = 'transparent';
      rootStyles.border = "1px solid #259BEB";
      rootStyles.fontSize = '14px';
      rootStyles.padding = '3px 24px';
      rootStyles["&:hover"] = {
        color : '#ffff',
        backgroundColor : "#259BEB",
      };
    }
    // if (props.color === "primary" && props.variant === "textSmall") {
    //   rootStyles.color = '#259BEB';
    //   rootStyles.backgroundColor = 'transparent';
    //   rootStyles.border = "1px solid transparent";
    //   rootStyles.fontSize = '14px';
    //   rootStyles.padding = '3px 24px';
    // }
    // if(props.color === "primary" && props.variant === "small") {
    //   rootStyles.color = MUITheme.palette.text.white.primary;
    //   rootStyles.backgroundColor = '#259BEB';
    //   rootStyles.border = "1px solid #136BD6";
    //   rootStyles.borderRadius = '4px';
    //   rootStyles.fontSize = '14px';
    //   rootStyles.padding = '3px 24px';
    //   rootStyles["&:hover"] = {
    //     backgroundColor: '#fff',
    //     color: '#259BEB'
    //   };
    // }
    if (props.variant === "text" && props.size === "small") {
      rootStyles.color = '#259BEB';
      rootStyles.backgroundColor = 'transparent';
      rootStyles.border = "1px solid transparent";
      rootStyles.fontSize = '14px';
      rootStyles.padding = '3px 24px';
    }
    if (props.variant === "text" && props.color === "secondary") {
      rootStyles.color = MUITheme.palette.text.black;
      rootStyles.backgroundColor = 'transparent';
      rootStyles.border = "1px solid transparent";
      rootStyles.fontSize = '14px';
      rootStyles.padding = '3px 24px';
    }
    if (props.variant === "outlined" && props.size === "small") {
      rootStyles.color = '#259BEB';
      rootStyles.backgroundColor = 'transparent';
      rootStyles.border = "1px solid #136BD6";
      rootStyles.fontSize = '14px';
      rootStyles.padding = '3px 24px';
    }
    if(props.color === "primary" && props.size === "small") {
      rootStyles.color = MUITheme.palette.text.white.primary;
      rootStyles.backgroundColor = '#259BEB';
      rootStyles.border = "1px solid #136BD6";
      rootStyles.borderRadius = '4px';
      rootStyles.fontSize = '14px';
      rootStyles.padding = '3px 24px';
      rootStyles["&:hover"] = {
        backgroundColor: '#fff',
        color: '#259BEB'
      };
    }
    if(props.disabled){
      rootStyles.backgroundColor = MUITheme.palette.disabled.background;
      rootStyles.borderColor = MUITheme.palette.disabled.border;
    }
    return rootStyles;
  },
}))(MuiButton);

export default Button;